import * as React from "react";
import PropTypes from 'prop-types';

const SvgPrint = props => {
  if (props.id !== "_svgprint") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 24 24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M19.52 6.047c1.224 0 2.08.822 2.08 2v5.846c0 1.178-.856 2-2.08 2h-.65l.25 2.769c0 .923-.64 1.538-1.6 1.538H6.48c-.96 0-1.6-.615-1.6-1.538l.246-2.769H4.48c-1.224 0-2.08-.822-2.08-2V7.97c0-1.115.875-1.923 2.08-1.923h15.04zm-2.72 4H7.2c-.24 0-.64.07-.64.538a.843.843 0 01-.004.078l-.716 8.033c.011.391.22.582.64.582h11.04c.418 0 .628-.19.64-.582l-.717-7.954a.908.908 0 01-.004-.08c0-.415-.209-.615-.64-.615zM15.68 16.2c.265 0 .48.207.48.462a.471.471 0 01-.48.461H8.32a.471.471 0 01-.48-.461c0-.255.214-.462.48-.462h7.36zm-.32-3.385c.265 0 .48.208.48.463a.47.47 0 01-.48.46H8.64a.47.47 0 01-.48-.46c0-.255.214-.463.48-.463h6.72zm.96-8.615c.265 0 .48.207.48.462a.471.471 0 01-.48.461H7.68a.47.47 0 01-.48-.461.47.47 0 01.48-.462h8.64z" fill="#202020" /></svg>;
};

SvgPrint.displayName = "_svgprint";
SvgPrint.propTypes = {
  id: PropTypes.string
};
SvgPrint.defaultProps = {
  id: ''
};
export default SvgPrint;